"use strict";

var _slicedToArray = require("/Users/sngr/develop/kitekure-site/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _regeneratorRuntime = require("/Users/sngr/develop/kitekure-site/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/Users/sngr/develop/kitekure-site/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/sngr/develop/kitekure-site/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var THREE = __importStar(require("three"));

var dom_to_canvas_1 = __importDefault(require("./dom-to-canvas"));

var constants_1 = require("./constants");

var gif_1 = __importDefault(require("./gif"));

var gifFor = new Map();

var VFXPlayer = /*#__PURE__*/function () {
  function VFXPlayer(canvas, pixelRatio) {
    var _this = this;

    _classCallCheck(this, VFXPlayer);

    this.canvas = canvas;
    this.isPlaying = false;
    this.pixelRatio = 2;
    this.elements = [];
    this.textureLoader = new THREE.TextureLoader();
    this.w = 0;
    this.h = 0;
    this.scrollX = 0;
    this.scrollY = 0;
    this.mouseX = 0;
    this.mouseY = 0;

    this.resize = function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iterator, _step, e, rect, _iterator2, _step2, _e, _rect;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof window !== "undefined")) {
                  _context.next = 45;
                  break;
                }

                _iterator = _createForOfIteratorHelper(this.elements);
                _context.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context.next = 15;
                  break;
                }

                e = _step.value;

                if (!(e.type === "text" && e.isInViewport)) {
                  _context.next = 13;
                  break;
                }

                rect = e.element.getBoundingClientRect();

                if (!(rect.width !== e.width || rect.height !== e.height)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 11;
                return this.rerenderTextElement(e);

              case 11:
                e.width = rect.width;
                e.height = rect.height;

              case 13:
                _context.next = 4;
                break;

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](2);

                _iterator.e(_context.t0);

              case 20:
                _context.prev = 20;

                _iterator.f();

                return _context.finish(20);

              case 23:
                _iterator2 = _createForOfIteratorHelper(this.elements);
                _context.prev = 24;

                _iterator2.s();

              case 26:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 37;
                  break;
                }

                _e = _step2.value;

                if (!(_e.type === "text" && !_e.isInViewport)) {
                  _context.next = 35;
                  break;
                }

                _rect = _e.element.getBoundingClientRect();

                if (!(_rect.width !== _e.width || _rect.height !== _e.height)) {
                  _context.next = 35;
                  break;
                }

                _context.next = 33;
                return this.rerenderTextElement(_e);

              case 33:
                _e.width = _rect.width;
                _e.height = _rect.height;

              case 35:
                _context.next = 26;
                break;

              case 37:
                _context.next = 42;
                break;

              case 39:
                _context.prev = 39;
                _context.t1 = _context["catch"](24);

                _iterator2.e(_context.t1);

              case 42:
                _context.prev = 42;

                _iterator2.f();

                return _context.finish(42);

              case 45:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 17, 20, 23], [24, 39, 42, 45]]);
      }));
    };

    this.scroll = function () {
      if (typeof window !== "undefined") {
        _this.scrollX = window.scrollX;
        _this.scrollY = window.scrollY;
      }
    };

    this.mousemove = function (e) {
      if (typeof window !== "undefined") {
        _this.mouseX = e.clientX;
        _this.mouseY = window.innerHeight - e.clientY;
      }
    };

    this.playLoop = function () {
      var now = Date.now() / 1000;

      _this.renderer.clear();

      _this.updateCanvasSize();

      var _iterator3 = _createForOfIteratorHelper(_this.elements),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var e = _step3.value;
          var rect = e.element.getBoundingClientRect();

          var isInViewport = _this.isRectInViewport(rect);

          if (isInViewport && !e.isInViewport) {
            e.enterTime = now;
            e.leaveTime = Infinity;
          }

          if (!isInViewport && e.isInViewport) {
            e.leaveTime = now;
          }

          e.isInViewport = isInViewport;

          if (isInViewport && now - e.leaveTime > e.release) {
            return;
          }

          e.uniforms["time"].value = now - e.startTime;
          e.uniforms["enterTime"].value = e.enterTime === -1 ? 0 : now - e.enterTime;
          e.uniforms["leaveTime"].value = e.leaveTime === -1 ? 0 : now - e.leaveTime;
          e.uniforms["resolution"].value.x = rect.width * _this.pixelRatio;
          e.uniforms["resolution"].value.y = rect.height * _this.pixelRatio;
          e.uniforms["offset"].value.x = rect.left * _this.pixelRatio;
          e.uniforms["offset"].value.y = (window.innerHeight - rect.top - rect.height) * _this.pixelRatio;
          e.uniforms["mouse"].value.x = _this.mouseX * _this.pixelRatio;
          e.uniforms["mouse"].value.y = _this.mouseY * _this.pixelRatio;

          for (var _i = 0, _Object$entries = Object.entries(e.uniformGenerators); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                key = _Object$entries$_i[0],
                gen = _Object$entries$_i[1];

            e.uniforms[key].value = gen();
          }

          var gif = gifFor.get(e.element);

          if (gif !== undefined) {
            gif.update();
          }

          if (e.type === "video" || e.isGif) {
            e.uniforms["src"].value.needsUpdate = true;
          }

          if (e.overflow) {
            _this.renderer.setViewport(0, 0, window.innerWidth, window.innerHeight);
          } else {
            _this.renderer.setViewport(rect.left, window.innerHeight - (rect.top + rect.height), rect.width, rect.height);
          }

          _this.camera.lookAt(e.scene.position);

          try {
            _this.renderer.render(e.scene, _this.camera);
          } catch (e) {
            console.error(e);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (_this.isPlaying) {
        requestAnimationFrame(_this.playLoop);
      }
    };

    this.renderer = new THREE.WebGLRenderer({
      canvas: canvas,
      alpha: true
    });
    this.renderer.autoClear = false;
    this.renderer.setClearAlpha(0);

    if (typeof window !== "undefined") {
      this.pixelRatio = pixelRatio || window.devicePixelRatio;
      window.addEventListener("resize", this.resize);
      window.addEventListener("scroll", this.scroll, {
        passive: true
      });
      window.addEventListener("mousemove", this.mousemove);
    }

    this.resize();
    this.scroll();
    this.camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0.1, 10);
    this.camera.position.set(0, 0, 1);
  }

  _createClass(VFXPlayer, [{
    key: "destroy",
    value: function destroy() {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", this.resize);
        window.removeEventListener("scroll", this.scroll);
        window.removeEventListener("mousemove", this.mousemove);
      }
    }
  }, {
    key: "updateCanvasSize",
    value: function updateCanvasSize() {
      if (typeof window !== "undefined") {
        var w = window.innerWidth;
        var h = window.innerHeight;

        if (w !== this.w || h !== this.h) {
          this.canvas.width = w;
          this.canvas.height = h;
          this.renderer.setSize(w, h);
          this.renderer.setPixelRatio(this.pixelRatio);
          this.w = w;
          this.h = h;
        }
      }
    }
  }, {
    key: "rerenderTextElement",
    value: function rerenderTextElement(e) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var texture, canvas;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                e.element.style.setProperty("opacity", "1");
                texture = e.uniforms["src"].value;
                canvas = texture.image;
                _context2.next = 6;
                return dom_to_canvas_1.default(e.element, canvas);

              case 6:
                if (!(canvas.width === 0 || canvas.width === 0)) {
                  _context2.next = 8;
                  break;
                }

                throw "omg";

              case 8:
                e.element.style.setProperty("opacity", "0");
                texture.needsUpdate = true;
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 12]]);
      }));
    }
  }, {
    key: "addElement",
    value: function addElement(element) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a, _b;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var shaderName, shader, rect, isInViewport, texture, type, isGif, gif, canvas, opacity, uniforms, uniformGenerators, keys, _i2, _keys, key, value, scene, geometry, material, now, elem;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                shaderName = opts.shader || "uvGradient";
                shader = constants_1.shaders[shaderName] || shaderName;
                rect = element.getBoundingClientRect();
                isInViewport = this.isRectInViewport(rect);
                isGif = false;

                if (!(element instanceof HTMLImageElement)) {
                  _context3.next = 19;
                  break;
                }

                type = "img";
                isGif = !!element.src.match(/\.gif/i);

                if (!isGif) {
                  _context3.next = 16;
                  break;
                }

                _context3.next = 11;
                return gif_1.default.create(element.src, this.pixelRatio);

              case 11:
                gif = _context3.sent;
                gifFor.set(element, gif);
                texture = new THREE.Texture(gif.getCanvas());
                _context3.next = 17;
                break;

              case 16:
                texture = this.textureLoader.load(element.src);

              case 17:
                _context3.next = 29;
                break;

              case 19:
                if (!(element instanceof HTMLVideoElement)) {
                  _context3.next = 24;
                  break;
                }

                texture = new THREE.VideoTexture(element);
                type = "video";
                _context3.next = 29;
                break;

              case 24:
                _context3.next = 26;
                return dom_to_canvas_1.default(element);

              case 26:
                canvas = _context3.sent;
                texture = new THREE.CanvasTexture(canvas);
                type = "text";

              case 29:
                texture.minFilter = THREE.LinearFilter;
                texture.magFilter = THREE.LinearFilter;
                texture.format = THREE.RGBAFormat;
                texture.needsUpdate = true;
                opacity = type === "video" ? "0.0001" : "0";
                element.style.setProperty("opacity", opacity);
                uniforms = {
                  src: {
                    value: texture
                  },
                  resolution: {
                    value: new THREE.Vector2()
                  },
                  offset: {
                    value: new THREE.Vector2()
                  },
                  time: {
                    value: 0.0
                  },
                  enterTime: {
                    value: -1.0
                  },
                  leaveTime: {
                    value: -1.0
                  },
                  mouse: {
                    value: new THREE.Vector2()
                  }
                };
                uniformGenerators = {};

                if (opts.uniforms !== undefined) {
                  keys = Object.keys(opts.uniforms);

                  for (_i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
                    key = _keys[_i2];
                    value = opts.uniforms[key];

                    if (typeof value === "function") {
                      uniforms[key] = {
                        value: value()
                      };
                      uniformGenerators[key] = value;
                    } else {
                      uniforms[key] = {
                        value: value
                      };
                    }
                  }
                }

                scene = new THREE.Scene();
                geometry = new THREE.PlaneGeometry(2, 2);
                material = new THREE.ShaderMaterial({
                  vertexShader: constants_1.DEFAULT_VERTEX_SHADER,
                  fragmentShader: shader,
                  transparent: true,
                  uniforms: uniforms
                });
                material.extensions = {
                  derivatives: true,
                  drawBuffers: true,
                  fragDepth: true,
                  shaderTextureLOD: true
                };
                scene.add(new THREE.Mesh(geometry, material));
                now = Date.now() / 1000;
                elem = {
                  type: type,
                  element: element,
                  isInViewport: isInViewport,
                  width: rect.width,
                  height: rect.height,
                  scene: scene,
                  uniforms: uniforms,
                  uniformGenerators: uniformGenerators,
                  startTime: now,
                  enterTime: isInViewport ? now : -1,
                  leaveTime: Infinity,
                  release: (_a = opts.release) !== null && _a !== void 0 ? _a : 0,
                  isGif: isGif,
                  overflow: (_b = opts.overflow) !== null && _b !== void 0 ? _b : false
                };
                this.elements.push(elem);

              case 46:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "removeElement",
    value: function removeElement(element) {
      var i = this.elements.findIndex(function (e) {
        return e.element === element;
      });

      if (i !== -1) {
        this.elements.splice(i, 1);
      }
    }
  }, {
    key: "updateTextElement",
    value: function updateTextElement(element) {
      var i = this.elements.findIndex(function (e) {
        return e.element === element;
      });

      if (i !== -1) {
        return this.rerenderTextElement(this.elements[i]);
      }

      return Promise.resolve();
    }
  }, {
    key: "play",
    value: function play() {
      this.isPlaying = true;
      this.playLoop();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.isPlaying = false;
    }
  }, {
    key: "isRectInViewport",
    value: function isRectInViewport(rect) {
      return rect.left <= this.w && rect.right >= 0 && rect.top <= this.h && rect.bottom >= 0;
    }
  }]);

  return VFXPlayer;
}();

exports.default = VFXPlayer;